import { render, staticRenderFns } from "./unprocessed.vue?vue&type=template&id=064aecf5&scoped=true"
import script from "./unprocessed.vue?vue&type=script&lang=js"
export * from "./unprocessed.vue?vue&type=script&lang=js"
import style0 from "./unprocessed.vue?vue&type=style&index=0&id=064aecf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064aecf5",
  null
  
)

export default component.exports